import z from 'zod';
import arrayUtil from '../../util/arrayUtil';

export const wizardStepNameSchema = z.enum(['flavourSelect', 'tasteSelect', 'mouthfeelSelect', 'categorySelect']);

type CategorySelectSearchParams = z.infer<typeof categorySelectSearchParamsSchema>;
type FlavourSelectSearchParams = z.infer<typeof flavourSelectSearchParamsSchema>;
type TasteSelectSearchParams = z.infer<typeof tasteSelectSearchParamsSchema>;
type MouthfeelSelectSearchParams = z.infer<typeof mouthfeelSelectSearchParamsSchema>;

export type ParsedSearchParams = CategorySelectSearchParams | FlavourSelectSearchParams | TasteSelectSearchParams | MouthfeelSelectSearchParams;

const categorySelectSearchParamsSchema = z.object({
  stepName: z.literal('categorySelect'),
  category: z.string().optional(),
});

const flavourSelectSearchParamsSchema = z.object({
  stepName: z.literal('flavourSelect'),
  category: z.string(),
  flavours: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
});

const tasteSelectSearchParamsSchema = z.object({
  stepName: z.literal('tasteSelect'),
  category: z.string(),
  flavours: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
  tastes: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
});

const mouthfeelSelectSearchParamsSchema = z.object({
  stepName: z.literal('mouthfeelSelect'),
  category: z.string(),
  flavours: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
  tastes: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
  mouthfeels: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
});

export const searchParamsSchema = z.discriminatedUnion('stepName', [
  categorySelectSearchParamsSchema,
  flavourSelectSearchParamsSchema,
  tasteSelectSearchParamsSchema,
  mouthfeelSelectSearchParamsSchema,
]);
